import { SearchIcon, Skeleton, Text, CheckIcon } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { generateClassesOfDropDown } from './drop-down-search.constants'

import styles from './drop-down-search.module.css'

import type { SupplierProps } from '@/types'
import type { DropDownSearchProps } from './drop-down-search.type'

export const DropDownSearch = ({
  data,
  isOpen,
  isLoading,
  selectedSupplier,
  onSelectSupplier,
  maxHeight,
}: DropDownSearchProps) => {
  const { t } = useTranslation('componentSupplierSearch')

  const classes = generateClassesOfDropDown(isOpen)

  const ItemLoading = () => (
    <li className={styles.item}>
      <Skeleton width="1.5rem" height="1.5rem" />

      <div className={styles.content}>
        <Skeleton width="100%" height="1.25rem" />

        <div className={styles.row}>
          <Skeleton width="6.25rem" height="1rem" />
          <Skeleton width="6.25rem" height="1rem" />
          <Skeleton width="6.25rem" height="1rem" />
        </div>
      </div>
    </li>
  )

  const Item = (supplier: SupplierProps) => (
    <li className={styles['list-style']}>
      <button
        className={styles.item}
        onClick={() => onSelectSupplier(supplier)}
      >
        <SearchIcon className={styles.icon} />

        <div className={styles.content}>
          <Text className={styles.title}>{supplier?.name}</Text>
        </div>

        {selectedSupplier?.uuid === supplier?.uuid && (
          <CheckIcon className={styles.icon} />
        )}
      </button>
    </li>
  )

  if (isLoading) {
    return (
      <div className={classes} style={{ maxHeight }}>
        <ul className={styles.list}>
          <ItemLoading />
          <ItemLoading />
          <ItemLoading />
        </ul>
      </div>
    )
  }

  if (data && data?.length > 0) {
    return (
      <div className={classes} style={{ maxHeight }}>
        {data?.map((item) => <Item key={item?.uuid} {...item} />)}
      </div>
    )
  }

  return (
    <div className={classes} style={{ maxHeight }}>
      <Text className={styles.item}>
        {t('catalogSearchEngineEmptyResults')}
      </Text>
    </div>
  )
}
